module.exports = __webpack_public_path__ + "img/applied.19f4886b.png";